import { render, staticRenderFns } from "./InvestmentPop.vue?vue&type=template&id=1f1548e6&scoped=true&"
import script from "./InvestmentPop.vue?vue&type=script&lang=js&"
export * from "./InvestmentPop.vue?vue&type=script&lang=js&"
import style0 from "./InvestmentPop.vue?vue&type=style&index=0&id=1f1548e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1548e6",
  null
  
)

export default component.exports